// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
export class Algorithm {
    constructor(data) {
        this.AlgorithmId = null;
        this.AlgorithmName = null;
        this.AlgorithmFilterName = null;
        this.InstrumentGroupIDs = null;
        this.RouteIDs = null;
        this.AlgorithmType = AlgorithmType.Unknown;
        this.AlgorithmStatus = AlgorithmStatus.Unknown;
        this.AlgorithmContainerType = AlgorithmContainerType.Unknown;
        this.AvailableRanges = [];
        this.CountryId = null;
        this.UpdateByMessage = (msg) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (msg == null) {
                return;
            }
            this.AlgorithmId = (_a = msg.AlgorithmId) !== null && _a !== void 0 ? _a : this.AlgorithmId;
            this.AlgorithmType = (_b = msg.AlgorithmType) !== null && _b !== void 0 ? _b : this.AlgorithmType;
            this.AlgorithmName = (_c = msg.AlgorithmName) !== null && _c !== void 0 ? _c : this.AlgorithmName;
            this.AlgorithmStatus = (_d = msg.AlgorithmStatus) !== null && _d !== void 0 ? _d : this.AlgorithmStatus;
            this.AlgorithmContainerType = (_e = msg.AlgorithmContainerType) !== null && _e !== void 0 ? _e : this.AlgorithmContainerType;
            this.AlgorithmFilterName = (_f = msg.AlgorithmFilterName) !== null && _f !== void 0 ? _f : this.AlgorithmFilterName;
            this.InstrumentGroupIDs = (_g = msg.InstrumentGroupIDs) !== null && _g !== void 0 ? _g : this.InstrumentGroupIDs;
            this.RouteIDs = (_h = msg.RouteIDs) !== null && _h !== void 0 ? _h : this.RouteIDs;
            this.CountryId = (_j = msg.CountryId) !== null && _j !== void 0 ? _j : this.CountryId;
            this.AvailableRanges = (_k = msg.AvailableRanges) !== null && _k !== void 0 ? _k : this.AvailableRanges;
        };
        this.UpdateByMessage(data);
    }
}
Algorithm.getRangeString = (range) => {
    switch (range.Type) {
        case AlgorithmRangeType.Day:
            return `${range.Value} ${range.Value === 1 ? Resources.getResource('period.Day') : Resources.getResource('period.Days')}`;
        case AlgorithmRangeType.Week:
            return `${range.Value} ${range.Value === 1 ? Resources.getResource('period.Week') : Resources.getResource('period.Weeks')}`;
        case AlgorithmRangeType.Month:
            return `${range.Value} ${range.Value === 1 ? Resources.getResource('period.Month') : Resources.getResource('period.Months')}`;
        default:
            return '';
    }
};
export const AlgorithmType = {
    Unknown: -1,
    HighLow: 0,
    GainersLosers: 1,
    TopVolume: 3,
    HistoricalGainersLosersTop: 4,
    MostTraded: 5,
    Heatmap: 6
};
export const AlgorithmContainerType = {
    Unknown: -1,
    None: 0,
    Country: 1,
    Custom: 2
};
export const AlgorithmStatus = {
    Unknown: -1,
    Running: 0,
    Stopped: 1,
    Inactive: 2
};
export const AlgorithmSubscribeType = {
    Subscribe: 0,
    Unsubscribe: 1
};
export var AlgorithmRangeType;
(function (AlgorithmRangeType) {
    AlgorithmRangeType[AlgorithmRangeType["Day"] = 0] = "Day";
    AlgorithmRangeType[AlgorithmRangeType["Week"] = 1] = "Week";
    AlgorithmRangeType[AlgorithmRangeType["Month"] = 2] = "Month";
})(AlgorithmRangeType || (AlgorithmRangeType = {}));
export class AlgorithmDataRange {
    constructor(type, value) {
        this._type = type;
        this._value = value;
    }
    get Type() {
        return this._type;
    }
    set Type(value) {
        this._type = value;
    }
    get Value() {
        return this._value;
    }
    set Value(value) {
        this._value = value;
    }
    isEqual(otherRange) {
        return this.Value === otherRange.Value && this.Type === otherRange.Type;
    }
    toString() {
        return `${this.Type} ${this.Value}`;
    }
    static fromString(str) {
        const splitArr = str.split(' ');
        const type = parseInt(splitArr[0]);
        const value = parseInt(splitArr[1]);
        return new AlgorithmDataRange(type, value);
    }
}
